import React, { createContext, useContext, useState } from 'react';

// TODO: tie company to threads
interface ThreadContextData {
  threadId: string | undefined;
  setThreadId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const OaiThreadContext = createContext<ThreadContextData | undefined>(undefined);

const useOaiThreadContext = () => {
  const context = useContext(OaiThreadContext);
  if (!context) {
    throw new Error('useOaiThreadContext must be used within a OaiThreadContextProvider');
  }
  return context;
};

interface ProviderProps {
  children: React.ReactNode;
}
function OaiThreadProvider({ children }: ProviderProps): JSX.Element {
  const [threadId, setThreadId] = useState<string | undefined>(undefined);

  return <OaiThreadContext.Provider value={{ threadId, setThreadId }}>{children}</OaiThreadContext.Provider>;
}

export { OaiThreadProvider, useOaiThreadContext };
